import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ViewCell } from '../../ng2-smart-table';

@Component({
  selector: 'app-custom-channel-icon',
  templateUrl: './custom-channel-icon.component.html',
  styleUrls: ['./custom-channel-icon.component.scss']
})
export class CustomChannelIconComponent implements ViewCell, OnInit {

  @Input() rowData: any;
  @Input() value: any;

  @Output() clicked: EventEmitter<any> = new EventEmitter();

  
  constructor() { }

  ngOnInit() {
  }

}
